import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=514672e7&scoped=true"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Article.vue?vue&type=style&index=0&id=514672e7&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "514672e7",
  "50d04d7a"
  
)

export default component.exports